import { Box, Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Level } from 'theme/enums';

import sentAsSpaIllustration from './assets/sentAsSpa.svg';

interface IProps {
  isResend?: boolean;
}

export const SendAsSpaSuccess = ({ isResend = false }: IProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        minHeight: 320,
        textAlign: 'center',
      }}
    >
      <Box component="img" src={sentAsSpaIllustration} alt="" sx={{ width: 184, height: 'auto' }} />

      <Typography level={Level.TITLE_LG}>{t('titleSendAsSpaSuccess')}</Typography>

      <Typography level={Level.BODY_MD} sx={{ color: 'neutral.600' }}>
        {t(isResend ? 'messageResendAsSpaSuccess' : 'messageSendAsSpaSuccess')}
      </Typography>
    </Stack>
  );
};
